import React from "react";
import {injectIntl} from "react-intl";

const AISLE_LABEL_STYLE = {
    width: "50px",
    height: "25px",
    textAlign: "center"
}

const AisleLabel = (props) => {

    const {aisleLabel} = props

    return (
        <div style={AISLE_LABEL_STYLE}>{aisleLabel}</div>
    )
}

export default injectIntl(AisleLabel);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/AisleLabel.js